import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

import colors from '@/assets/styles/_export.scss';

Vue.use(Vuetify);

const values = {};
const requireComponent = require.context('@/components/shared/icons', false, /[A-Z]\w+\.(vue)$/);
requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName);
  const componentName = fileName
    .split('/')
    .pop()
    .replace(/\.\w+$/, '');

  const iconName = componentName.split('Icon')[0].toLocaleLowerCase();
  values[iconName] = {
    component: componentConfig.default,
  };
});

export default new Vuetify({
  icons: {
    values,
  },
  theme: {
    themes: {
      light: colors,
    },
  },
  lang: {
    current: 'pl',
  },
});
